import { IS_CLOUD_BANNED, IS_CLOUD_CREATED, IS_CLOUD_LOCKED } from 'reactApp/appHelpers/configHelpers';
import { EFrom } from 'reactApp/components/SharingWindow/Sharing.types';
import { createNewAutoDeleteFolder, openPublishDialog, removeRequest } from 'reactApp/modules/modifying/modifying.actions';
import { isDomainFolder as isDomainFolderStorage } from 'reactApp/modules/storage/folder.helpers';
import { store as reduxStore } from 'reactApp/store';
import { noopVoid } from 'reactApp/utils/helpers';
import { getSize, getSizeInteger } from 'reactApp/utils/sizeHelper';

import {
    getDomainRestrictionsForBitmask as getDomainRestrictionsForBitmaskHelper,
    getDomainRestrictionsForItems as getDomainRestrictionsForItemsHelper,
} from './getDomainHelpers';

export const isDomainFolder = (item) => item && item.isFolder && isDomainFolderStorage(item);
export const getDomainRestrictionsForBitmask = (bitmask) => {
    return getDomainRestrictionsForBitmaskHelper(bitmask);
};

export const getDomainRestrictionsForItems = (items) => {
    const reduxState = reduxStore.getState();
    return getDomainRestrictionsForItemsHelper(items, reduxState);
};

export const getDownloadItemSize = (items, withoutRestricted = false) => {
    if (!items.length) {
        return '';
    }

    if (!items.every((item) => typeof item?.size === 'number')) {
        return;
    }

    if (items.length === 1) {
        const size =
            withoutRestricted && items[0].isFolder && 'sizeWithoutRestricted' in items[0] ? items[0].sizeWithoutRestricted : items[0].size;

        return getSize(getSizeInteger(size));
    }

    return getSize(items.reduce((acc, cur) => acc + getSizeInteger(cur.size), 0));
};

export const hideDownloadItemSize = (items) => {
    if (!items.length || !items.every((item) => typeof item?.size === 'number')) {
        return true;
    }
    return items.reduce((acc, cur) => acc + getSizeInteger(cur.size), 0) === 0;
};

export const isEmptyFolder = (currentFolder) => {
    if (!currentFolder) {
        return true;
    }

    return currentFolder.hasOwnProperty('size') && currentFolder.size === 0;
};

export const removeItemsWithoutDialog = ({ items }) =>
    reduxStore.dispatch(
        removeRequest({
            items,
            withRemoveDialog: false,
        })
    );

// Удаление файлов с окном подтверждения
export const removeItems = ({ items, onSuccess = noopVoid }) => {
    reduxStore.dispatch(removeRequest({ items, withRemoveDialog: true, onSuccess }));
};

export const openShareDialog = ({ item }) =>
    reduxStore.dispatch(
        openPublishDialog({
            item,
            from: EFrom.SHARING,
        })
    );

export const createAutoDeleteFolder = () => reduxStore.dispatch(createNewAutoDeleteFolder());

export const getIsCloudAvailabe = () => IS_CLOUD_CREATED && !IS_CLOUD_BANNED && !IS_CLOUD_LOCKED;
